exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section.section2 {\r\n    margin: 0;\r\n    background-color: #000;\r\n    color: #FFF;\r\n    padding: 15px;\r\n}\r\n\r\n\r\n.tagweb{\r\n    margin: auto;\r\n    display: table;\r\n}\r\n.tagweb a {\r\n    float: left;\r\n    display: block;\r\n    margin-bottom: 4px;\r\n    margin-right: 4px;\r\n    padding: 5px 10px;\r\n    font-size: 12px !important;\r\n    line-height: 1.4em !important;\r\n    color: #fff !important;\r\n    text-decoration: none;\r\n    font-weight: 300;\r\n    letter-spacing: 1px;\r\n    transition: all .4s linear;\r\n    background-color: #3a5795;\r\n}\r\n\r\n.message .big-title {\r\n    letter-spacing: -0.80px;\r\n    color: #ffffff;\r\n    text-transform: uppercase;\r\n    font-size: 38px;\r\n    font-weight: 700;\r\n}\r\n\r\n.message span {\r\n    color: #3a5795;\r\n}\r\n\r\n.message .small-title {\r\n    color: #ffffff;\r\n    margin: 30px 0 0;\r\n    font-size: 18px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.message .btn {\r\n    margin-top: 30px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/src/app/components/homepage/homepage.component.css
// module id = ../../../../../src/app/components/homepage/homepage.component.css
// module chunks = main